// src/Screens/CareerVideosLoader.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import animationData from '../Assets/career-videos-loader.json';

const CareerVideosLoader = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/career-videos');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="bg-white/80 backdrop-blur-md rounded-[30px] shadow-xl p-6 flex flex-col justify-center items-center min-h-[70vh] w-full max-w-[950px] mx-auto gap-8">
      <div className="w-[300px] md:w-[400px] lg:w-[500px]">
        <Lottie animationData={animationData} loop={true} />
      </div>
      <p className="text-lg md:text-xl font-semibold text-stone-800 font-sora text-center">
        Kumar is curating the best career videos for you... 🍿
      </p>
    </div>
  );
};

export default CareerVideosLoader;
